module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day02_06_stay-7f77b6234741513e2a1bfc723f8d715f.jpg";